export default __webpack_public_path__ + "static/media/inbal_zafir_lavie.6cb073f7.jpeg";